module.exports = __webpack_public_path__ + "static/media/room-07.5645f3f6.jpg";